module.exports = __webpack_public_path__ + "img/gauge-blue.bdf198ca.svg";